import * as types from '../mutation-types'
import api from '../../api/index'
import validator from '../../tools/validator'
import loginChecker from '../../tools/loginChecker'
import JsBridge from '../../tools/jsBridge'

// initial state
const state = {
  userInfo: window.localStorage.userInfo ? JSON.parse(window.localStorage.userInfo) : {},
  tempLoginPhone: window.localStorage.tempLoginPhone,
  isFirstIn: window.localStorage.isFirstIn !== 'false',
  logoutToLogin: false
}

// getters
const getters = {
  sessionId: () => {
    return state.userInfo.sessionId
  },
  userId: () => {
    return state.userInfo.id
  },
  isLogin: () => {
    if (state && typeof state.userInfo === 'object') {
      return !validator.checkEmpty(state.userInfo.sessionId)
    } else {
      return false
    }
  },
  phone: () => {
    return state.userInfo.account
  },
  hasRealNamed: () => {
    return state.userInfo.isClient === 1
  },
  hasSettingPwd: () => {
    return (state.userInfo.isHavePwd + '') === '1'
  }
}

// actions
const actions = {
  login: function (context, body) {
    return new Promise((resolve, reject) => {
      api.user.login(body).then(res => {
        context.commit(types.LOGIN_SUCCESS, res)
        context.commit(types.LOGOUT_TO_LOGIN, false)
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  quickLogin: function (context, body) {
    return new Promise((resolve, reject) => {
      api.user.quickLogin(body).then(res => {
        context.commit(types.LOGIN_SUCCESS, res)
        context.commit(types.LOGOUT_TO_LOGIN, false)
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  // 设置密码
  setPassword: function (context, body) {
    return new Promise((resolve, reject) => {
      api.user.setPasswordForNewUser(body).then(res => {
        context.commit(types.UPDATE_SETTINGPWD_STATE, res)
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  logout: function (context, body) {
    if (getters.isLogin()) {
      api.user.logout({ openId: window.localStorage.getItem('openId') }).then(res => {
        JsBridge.loginOutToNative()
      }).catch(() => {
      })
      context.commit(types.LOGIN_OUT)
    }
  },
  logoutToLogin: function (context, val) {
    context.commit(types.LOGOUT_TO_LOGIN, val)
    if (val) {
      actions.logout(context)
      loginChecker.checkLogin().then(() => {
      });
    }
  },
  storeLoginPhone: function (context, body) {
    context.commit(types.TEMP_LOGIN_PHONE, body)
  },
  saveHasFirstIn: function (context) {
    context.commit(types.IS_FIRST_IN)
  },
  realName: function (context, body) {
    return new Promise((resolve, reject) => {
      api.user.realName(body).then(res => {
        context.commit(types.UPDATE_REALNAME_STATE, res)
        resolve(res)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  saveHasAuthorize: function (context) {
    context.commit(types.UPDATE_AUTHEN_STATE)
  },
  saveUserInfo: function (context, val) {
    context.commit(types.LOGIN_SUCCESS, val)
    context.commit(types.LOGOUT_TO_LOGIN, false)
  },
  clearUserInfoAndLogOutTag: function (context) {
    context.commit(types.LOGIN_OUT)
    context.commit(types.LOGOUT_TO_LOGIN, true)
  }
}

// mutations
const mutations = {
  [types.LOGIN_SUCCESS](state, userInfo) {
    window.localStorage.setItem('userInfo', JSON.stringify(userInfo.body))
    state.userInfo = userInfo.body
  },
  [types.LOGIN_OUT](state) {
    window.localStorage.setItem('userInfo', '')
    state.userInfo = ''
  },
  [types.TEMP_LOGIN_PHONE](state, phone) {
    window.localStorage.setItem('tempLoginPhone', phone)
    state.tempLoginPhone = phone
  },
  [types.UPDATE_SETTINGPWD_STATE](state) {
    let userInfo = state.userInfo
    userInfo.isHavePwd = 1
    window.localStorage.setItem('userInfo', JSON.stringify(userInfo))
    state.userInfo = userInfo
  },
  [types.IS_FIRST_IN](state) {
    window.localStorage.setItem('isFirstIn', false)
    state.isFirstIn = false
  },
  [types.LOGOUT_TO_LOGIN](state, value) {
    state.logoutToLogin = value
  },
  [types.UPDATE_REALNAME_STATE](state) {
    let userInfo = state.userInfo
    userInfo.isClient = 1
    window.localStorage.setItem('userInfo', JSON.stringify(userInfo))
    state.userInfo = userInfo
  },
  [types.UPDATE_AUTHEN_STATE](state) {
    let userInfo = state.userInfo
    userInfo.isAuthBhe = false
    window.localStorage.setItem('userInfo', JSON.stringify(userInfo))
    state.userInfo = userInfo
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js